export const useGameComposable = () => {
  // const { t } = useI18n();
  const router = useRouter();
  const currentRoute = router.currentRoute;
  const { t } = useI18n();
  // DEFINING GAMES
  const games = [];
  // return ref();
  const currentGameSlug = currentRoute.value?.params?.gameSlug || "";
  const currentGamePackSlug = currentRoute.value?.params?.gamePackSlug || "";
  const currentGameRoute = currentRoute;
  const categoryPackSlug = currentRoute.value?.params?.categoryPackSlug;

  const currentGame = computed(() => {
    return games?.find(
      (game) => game.slug === currentRoute.value?.params?.gameSlug
    );
  });

  const extraPack = computed(() => {
    if (currentRoute.value?.params?.gameSlug === "counter-strike-2-boost") {
      return {
        id: 25,
        image: "/images/games/counter-strike-2-boost/packs/faceit_boost.webp",
        perks: [
          {
            title: t(
              "counter-strike-2-boost.counter-strike-2-faceit-boost.perks.1"
            ),
          },
          {
            title: t(
              "counter-strike-2-boost.counter-strike-2-faceit-boost.perks.2"
            ),
          },
          {
            title: t(
              "counter-strike-2-boost.counter-strike-2-faceit-boost.perks.3"
            ),
          },
        ],
        short_title: t(
          "counter-strike-2-boost.counter-strike-2-faceit-boost.short_title"
        ),
        slug: "counter-strike-2-faceit-division-boosting",
        title: t("counter-strike-2-boost.counter-strike-2-faceit-boost.title"),
      };
    }
    return null;
  });
  return {
    currentGameSlug,
    currentGamePackSlug,
    currentGameRoute,
    currentGame,
    extraPack,
    categoryPackSlug,
  };
};
